import { withSvgIcon } from './withSvgIcon';

export const ArrowUpDown = withSvgIcon(
  <>
    <path
      d="M16 8L12 4L8 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M16 16L12 20L8 16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
